import { Inject, Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { APP_CONFIG } from '../config/app-config.service';
import { IAppConfig } from '../config/app-config.model';
import { LanguageService } from '../language.service';
import * as uuid from 'uuid';
import { XnStorageService } from '../xn-storage';
import { AUTH_KEY, AuthState } from '../auth/auth.models';

@Injectable()
export class ApiUrlInterceptor implements HttpInterceptor {
    private apiBaseUrl = '';
    public constructor(
      @Inject(APP_CONFIG) protected config: IAppConfig,
      private languageService: LanguageService,
      private localStorageService: XnStorageService,
    ){
        this.apiBaseUrl = config.apiServer.endpoint;
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if(req.url.indexOf('http') !== -1 || /^\.\//i.test(req.url)){
            return next.handle(req);
        }

        let modifyHeaders =req.headers.set('clientid', this.config.apiServer.clientId)
            .set('Application', this.config.application)
            .set('Content-Language', this.languageService.getCurrentCultureCode());

        // Add "request-key" to prevent duplicate for POST request
        if(req.method === 'POST'){
            modifyHeaders = modifyHeaders.set('request-key', uuid.v4());
        }

        if(!this.isLoggedIn()){
            if(!modifyHeaders.has('Authorization')){
                modifyHeaders = modifyHeaders.set('Authorization', 'anonymous');
            }
        }

        const modifyRequest = req.clone({
            url: `${this.apiBaseUrl}/${req.url}`,
            withCredentials: true,
            headers: modifyHeaders
        });
        return next.handle(modifyRequest);
    }

    private isLoggedIn(): boolean{
        const auth : AuthState = this.localStorageService.getItem(AUTH_KEY);
        return auth && auth.profileId ? true : false;
    }
}